import { ATTENDANCE_TRACKING_SHIFT_STATUS } from './attendanceUtil';
import { departmentFilter } from 'containers/Pages/People/Personnel/Layouts/options.jsx';

export const filters = (attendanceList, userAssignedDepartments = []) => {
  return {
    RegularFilters: [
      {
        label: 'Personnel',
        field: 'personnel',
        type: 'select',
        options: attendanceList,
      },
      {
        label: 'Shift Status',
        field: 'shiftStatus',
        type: 'select',
        multiple: true,
        options: ATTENDANCE_TRACKING_SHIFT_STATUS,
      },
      {
        label: 'Date From',
        field: 'fromDate',
        type: 'date-picker',
      },
      {
        label: 'Date To',
        field: 'toDate',
        type: 'date-picker',
      },
    ],
    AdvancedFilters: [...departmentFilter(userAssignedDepartments)],
  };
};
